import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import 'bootstrap3/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import './style.css'

// Suppress warnings from unmaintained third-party libraries.
const ignoreWarn = [
  'Warning: componentWillMount has been renamed',
  'Warning: componentWillReceiveProps has been renamed',
  'As of March 1st, 2025, google.maps.places.AutocompleteService'
]
const _consoleWarn = console.warn
console.warn = (...args) => {
  if (typeof args[0] === 'string' && ignoreWarn.some(text => args[0].startsWith(text))) return
  _consoleWarn(...args)
}

const ignoreErrors = []
const _consoleError = console.error
console.error = (...args) => {
  if (typeof args[0] === 'string' && ignoreErrors.some(text => args[0].startsWith(text))) return
  _consoleError(...args)
}

document.body.className =
  window.location.hostname.indexOf('beta') >= 0 || window.location.hostname.indexOf('localhost') >= 0 ? 'beta' : ''

document.body.className =
  window.location.hostname.indexOf('localhost') >= 0 || window.location.hostname.indexOf('localhost') >= 0
    ? 'localhost'
    : document.body.className

ReactDOM.render(<App />, document.getElementById('root'))
